import React from 'react';
import RefinedInPageBanner from './RefinedInPageBanner';
import RefinedPromoBanner from './RefinedPromoBanner';
import RefinedInPageBannerV2 from './RefinedInPageBannerV2';
import RefinedPromoBannerV2 from './RefinedPromoBannerV2';

const Banner = ({ bannerContent }) => {
    if (!bannerContent)
        return '';

    if (bannerContent.__typename === 'Contentstack_refined_in_page_banner')
        return (<RefinedInPageBanner refinedInPageBannerContent={bannerContent} />)

    if (bannerContent.__typename === 'Contentstack_refined_in_page_banner_v2')
        return (<RefinedInPageBannerV2 refinedInPageBannerContent={bannerContent} />)

    if (bannerContent.__typename === 'Contentstack_refined_promo_banner')
        return (<RefinedPromoBanner refinedPromoBannerContent={bannerContent} />)
    
    if (bannerContent.__typename === 'Contentstack_refined_promo_banner_v2')
        return (<RefinedPromoBannerV2 refinedPromoBannerContent={bannerContent} />)

    return '';
}

export default Banner;
